import * as Yup from 'yup'

export const initialValues = {
    assetIsDown: false,
    additionalDetails: '',
    description: '',
    faultCode: '',
    locationDetails: '',
    poNumber: '',
}

export const validationSchema = Yup.object().shape({
    assetIsDown: Yup.boolean(),
    additionalDetails: Yup.string().max(
        255,
        'Additional details too long (maximum 255 characters',
    ),
    description: Yup.string()
        .required('This field is required')
        .max(255, 'Description too long (maximum 255 characters)'),
    faultCode: Yup.string(),
    locationDetails: Yup.string(),
    poNumber: Yup.string().max(
        20,
        'PO number too long (maximum 20 characters)',
    ),
})
